import { useCallback, useState } from "react"

export function useToggle(defaultState = false) {
  const [state, setState] = useState(defaultState)
  const toggle = useCallback(() => setState(state => !state), [])

  return [state, toggle]
}
